import { myPlannerApi } from '@/entities/planner/model/my-planner.api';
import type { PlannerView } from '@/entities/planner';
import { useEffect, useState } from 'react';

/**
 * PLANNER 전용: 현재 로그인한 플래너의 프로필 조회
 * /api/v1/planners/me 사용
 */
export function useMyPlanner(enabled: boolean) {
  const [planner, setPlanner] = useState<PlannerView | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!enabled) {
      setPlanner(null);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    myPlannerApi
      .getMyPlanner()
      .then(setPlanner)
      .catch(() => setPlanner(null))
      .finally(() => setIsLoading(false));
  }, [enabled]);

  return {
    planner,
    isLoading,
  };
}
